import { useState } from 'react';
import api from '../../domain/api';

const GoogleAdsUploader = () => {
  const [report, setReport] = useState(null);

  const fetchReport = async () => {
    try {
      const resp = await api.post('/facebook-ads/test-cpl-benchmark');
      setReport(resp.data);
    } catch (error) {
      console.error('Error fetching Super Admin report:', error);
    }
  };

  const sendGoogleAdsReport = async () => {
    try {
      const resp = await api.post('/google-ads/test-cpl-benchmark');
      setReport(resp.data);
    } catch (error) {
      console.error('Error fetching Google Ads report:', error);
    }
  };

  const sendAdminReport = async () => {
    try {
      const resp = await api.get('/reports/test-daily-report');
      setReport(resp.data);
    } catch (error) {
      console.log('Error fetching Admin report:', error);
    }
  };

  return (
    <div className='p-4'>
      <button onClick={fetchReport}>Send the Facebook Ads Report</button>
      <button onClick={sendGoogleAdsReport}>Send the Google Ads Report</button>

      <button onClick={sendAdminReport}>Send the Admin Report</button>

      <pre>{JSON.stringify(report, null, 2)}</pre>
    </div>
  );
};

export default GoogleAdsUploader;
